import { render, staticRenderFns } from "./realtest_paper.vue?vue&type=template&id=29a864e2&scoped=true"
import script from "./realtest_paper.vue?vue&type=script&lang=js"
export * from "./realtest_paper.vue?vue&type=script&lang=js"
import style0 from "./realtest_paper.vue?vue&type=style&index=0&id=29a864e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a864e2",
  null
  
)

export default component.exports